import React from 'react'
import { Column } from 'primereact/column'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import DataTableComp from '../common/data-table/DataTableComp'
import {
  bodyParseDate,
  bodyProgressBar,
} from '../common/data-table/column-types/ColumnTypes'
import { parseProduct } from '../../utils/helpers/common'
import editNumberRowColumn from '../common/data-table/editors/editNumberRowColumn'
import rowEditor from '../common/data-table/column-types/rowEditor'
import TanksService from '../../services/alvic/tanks/tanks.service'

const TanksDataTable = ({ value, reload, pagerOptions }) => {
  const { formatMessage: msg } = useIntl()
  const { id } = useParams()

  const onRowEditComplete = async ({ newData }) => {
    const resp = await TanksService.updateMinStock({
      ownStationId: id,
      tankNum: newData?.tankNum,
      body: newData,
    })
    if (resp) reload()
  }

  const minStockAlert = (rowData) => {
    const product = parseProduct(rowData?.product)
    if (rowData?.minStock > rowData?.quantity) {
      return <span style={{ color: '#EF6A20' }}> {product} </span>
    }
    return product
  }

  const redenrColumns = [
    <Column
      key={Math.random()}
      sortable
      field="readDate"
      header={msg({ id: 'readDate' })}
      body={(rowData) =>
        bodyParseDate({ date: rowData?.readDate, dateTimeFormat: true })
      }
    />,
    <Column
      key={Math.random()}
      sortable
      field="product"
      header={msg({ id: 'product' })}
      body={(rowData) => minStockAlert(rowData)}
    />,
    <Column
      key={Math.random()}
      sortable
      field="capacity"
      header={msg({ id: 'capacity' })}
    />,
    <Column
      key={Math.random()}
      sortable
      field="percentageFilled"
      header={msg({ id: 'stock' })}
      body={(rowData) => bodyProgressBar(rowData?.percentageFilled)}
    />,

    <Column
      key={Math.random()}
      sortable
      field="quantity"
      header={msg({ id: 'quantity' })}
    />,
    <Column
      key={Math.random()}
      sortable
      field="remainingCapacity"
      header={msg({ id: 'free' })}
    />,
    <Column
      key={Math.random()}
      sortable
      field="consumptionDaily"
      header={msg({ id: 'daily.consumption' })}
    />,
    <Column
      key={Math.random()}
      sortable
      field="fuelDateEnd"
      header={msg({ id: 'date.finish' })}
      body={(rowData) =>
        bodyParseDate({ date: rowData?.fuelDateEnd, dateTimeFormat: true })
      }
    />,
    <Column
      key={Math.random()}
      field="minStock"
      header={msg({ id: 'minStock' })}
      {...(reload && editNumberRowColumn({ sortable: true }))}
    />,
    reload && <Column {...rowEditor()} key={Math.random()} />,
  ]

  return (
    <DataTableComp
      disableAutoheight
      pagerOptions={pagerOptions}
      tableOptions={{
        value,
        //dataKey: "_id",
        editMode: 'row',
        onRowEditComplete,
      }}
      columns={redenrColumns}
    />
  )
}

export default TanksDataTable
